import { ColumnDef } from '@tanstack/react-table'
import { GameProviderWithBannerListTableData } from '@/modules/game/type'
import { IsActiveGameProvider } from './components/IsActiveGameProvider'
import EditOrderGameProvider from './components/EditOrderGameProvider'
import EditNameGameProvider from './components/EditNameGameProvider'
import EditProviderBanner from './components/EditProviderBanner'
import EditProviderLogo from './components/EditProviderLogo'
import { IsNewProvider } from './components/IsNewProvider'
import { IsPopularProvider } from './components/IsPopularProvider'
import EditDefaultPresetId from './components/EditDefaultPresetId'
import EditDefaultPresetNumber from './components/EditDefaultPresetNumber'
import { getProviderPresetType, PresetType } from '@/modules/game/utils'

export const columns: ColumnDef<GameProviderWithBannerListTableData>[] = [
	{
		accessorKey: 'order',
		header: 'ลำดับ',
		cell: ({ row }) => row.original.order || '-',
	},
	{
		accessorKey: 'displayName',
		header: 'ชื่อค่ายเกมที่โชว์',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				<span>{row.original.displayName}</span>
				<EditNameGameProvider row={row.original} />
			</div>
		),
	},
	{
		accessorKey: 'name',
		header: 'ชื่อค่ายเกมเริิ่มต้น',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				<span>{row.original.name}</span>
				<EditNameGameProvider row={row.original} />
			</div>
		),
	},
	{
		accessorKey: 'bannerUrl',
		header: 'แบนเนอร์',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				{row.original.bannerUrl ? (
					<div className="h-12 w-20 overflow-hidden rounded border">
						<img
							src={row.original.bannerUrl}
							alt={`${row.original.displayName} banner`}
							className="h-full w-full object-cover"
						/>
					</div>
				) : (
					<div className="flex h-12 w-20 items-center justify-center rounded border bg-gray-200 text-xs text-gray-500">
						ไม่มี
					</div>
				)}
				<EditProviderBanner row={row.original} />
			</div>
		),
	},
	{
		accessorKey: 'logoUrl',
		header: 'โลโก้',
		cell: ({ row }) => (
			<div className="flex items-center gap-2">
				{row.original.logoUrl ? (
					<div className="h-12 w-12 overflow-hidden rounded border">
						<img
							src={row.original.logoUrl}
							alt={`${row.original.displayName} logo`}
							className="h-full w-full object-cover"
						/>
					</div>
				) : (
					<div className="flex h-12 w-12 items-center justify-center rounded border bg-gray-200 text-xs text-gray-500">
						ไม่มี
					</div>
				)}
				<EditProviderLogo row={row.original} />
			</div>
		),
	},
	{
		accessorKey: 'isActive',
		header: 'สถานะ',
		cell: ({ row }) => <IsActiveGameProvider row={row.original} />,
	},
	{
		accessorKey: 'isPopular',
		header: 'ยอดนิยม',
		cell: ({ row }) => <IsPopularProvider row={row.original} />,
	},
	{
		accessorKey: 'isNew',
		header: 'ค่ายใหม่',
		cell: ({ row }) => <IsNewProvider row={row.original} />,
	},
	{
		accessorKey: 'defaultPreset',
		header: 'RTP ตั้งต้น',
		cell: ({ row }) => {
			const presetType = getProviderPresetType(row.original.name)
			if (presetType === PresetType.PresetId) {
				return <EditDefaultPresetId row={row.original} />
			}
			if (presetType === PresetType.PresetNumber) {
				return <EditDefaultPresetNumber row={row.original} />
			}
			const displayValue = row.original.defaultPreset
				? row.original.defaultPreset
				: row.original.defaultPresetNumber
					? `${row.original.defaultPresetNumber}%`
					: '-'
			return <span className="text-sm">{displayValue}</span>
		},
	},
	{
		accessorKey: 'action',
		header: 'แก้ไขลำดับ',
		cell: ({ row }) => <EditOrderGameProvider row={row.original} />,
	},
]
